module.exports = __webpack_public_path__ + "static/img/pj-hk21.2f4e95e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/pj-hk21.png
// module id = bz1n
// module chunks = 1